import { toast } from "react-toastify"
import moment from "moment";
import { isEmpty, isEqual } from "lodash";
import { pdf } from "@react-pdf/renderer";
import { CHATTER_CLIENT_DETAIL, CHATTER_CLIENT_LIST, HOME_EDUCATION_CLIENT_DETAIL, HOME_EDUCATION_CLIENT_LIST, PRIVATE_CLIENT_DETAIL, PRIVATE_CLIENT_LIST, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { generatePath } from "react-router-dom";
import parse from "html-react-parser";
import { AlertCircle, Check, CheckCircle } from "react-feather";

export const successMessageToast = (msg, options = {}) => {
  toast.success(msg, {
    // style: {
    // },
        icon: <CheckCircle size={20} color="#93278F" />,
     progressStyle: {
    background: '#93278F',
  },
    ...options
  });
}

export const errorMessageToast = (msg, options = {}) => {
  toast.error(msg, {
    // style: {
    // },
        icon: <AlertCircle size={20} color="#93278F" />,
     progressStyle: {
    background: '#93278F',
  },
    ...options
  });
}

// export const errorMessageToast = (msg, options = {}) => {
//   toast.error(msg, options);
// }

export const promiseToast = async (promise, options = {}) => {
  // if(options?.toastId && toast.isActive(options?.toastId)) {
  //   toast.remove(options?.toastId);
  // }
  return toast.promise(
    promise, {
    pending: 'Loading...',
    success: 'Success',
    error: 'Failed',
    ...options
  },
    options
  );
}

export const confirmMsg = async (msg = "Are you sure?") => {
  if (!window.confirm(msg)) {
    return false;
  }

  return true;
}

export function secondsToMinutesAndSeconds(inputSeconds) {
  var minutes = Math.floor(inputSeconds / 60);
  var seconds = inputSeconds % 60;
  return {
    minutes,
    seconds
  };
}

export function userFullName(user) {

  let fullName = capitalize(user?.firstname);
  if (user?.lastname) {
    fullName += " " + capitalize(user?.lastname);
  }

  return fullName;
}

export function userFullNameReverse(user, separator = ",") {
  let fullName = capitalize(user?.lastname);
  if (user?.firstname) {
    fullName += `${separator ? separator : ""} ${capitalize(user?.firstname)}`;
  }

  return fullName;
}

export function printNameInitials(user) {
  let output = user?.firstname.charAt(0).toUpperCase();
  if (user?.lastname) {
    output += user?.lastname.charAt(0).toUpperCase();
  }

  return output;
}

export function uniqueString(length = 10) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charset.length);
    result += charset[randomIndex];
  }
  return result;
}

export function getNameInitials(user) {
  if (!user?.firstname || !user?.lastname) return '';

  const firstInitial = user?.firstname[0].toUpperCase();
  const lastInitial = user?.lastname[0].toUpperCase();

  return `${firstInitial}${lastInitial}`;
}


export function dateFormat(date, outputFormat = "DD/MM/YYYY", inputFormat = null) {
  if (!date || !moment(date, inputFormat).isValid()) {
    return "--"
  }

  return moment(date, inputFormat).format(outputFormat);
}

export function dateFormatLocal(date, outputFormat = "DD/MM/YYYY") {
  if (!date || !moment(date).isValid()) {
    return "--"
  }

  return moment(date).format(outputFormat);
}


export const formatString = (input, capitalizeEachWord = true) => {
  if (!input) {
    return "--";
  }

  let formatted = input
    .toLowerCase()
    .replace(/_/g, " ");

  if (capitalizeEachWord) {
    formatted = formatted
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } else {
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
  }

  return formatted;
};

export function filterNullValues(obj) {

}

export function getAge(dateOfBirth) {
  const now = moment();
  const birthDate = moment(dateOfBirth);

  const years = now.diff(birthDate, 'years');
  birthDate.add(years, 'years'); // Adjust birthDate by the number of years

  const months = now.diff(birthDate, 'months');

  // Format output based on whether there are months or not
  if (months === 0) {
    return `${years}y`;
  } else {
    return `${years}y, ${months}m`;
  }

  if (months === 0) {
    return `${years} year${years > 1 ? 's' : ''}`;
  } else {
    return `${years} year${years > 1 ? 's' : ''} ${months} month${months > 1 ? 's' : ''}`;
  }
}


function hslToHex(h, s, l) {
  s /= 100;
  l /= 100;

  const c = (1 - Math.abs(2 * l - 1)) * s; // Chroma
  const x = c * (1 - Math.abs((h / 60) % 2 - 1));
  const m = l - c / 2;

  let r, g, b;

  if (h >= 0 && h < 60) {
    r = c; g = x; b = 0;
  } else if (h >= 60 && h < 120) {
    r = x; g = c; b = 0;
  } else if (h >= 120 && h < 180) {
    r = 0; g = c; b = x;
  } else if (h >= 180 && h < 240) {
    r = 0; g = x; b = c;
  } else if (h >= 240 && h < 300) {
    r = x; g = 0; b = c;
  } else {
    r = c; g = 0; b = x;
  }

  const rHex = Math.round((r + m) * 255).toString(16).padStart(2, '0');
  const gHex = Math.round((g + m) * 255).toString(16).padStart(2, '0');
  const bHex = Math.round((b + m) * 255).toString(16).padStart(2, '0');

  return `#${rHex}${gHex}${bHex}`;
}

export function getColorByIndex(index) {
  const hue = (index * 37) % 360; // Shift hue based on index
  return hslToHex(hue, 100, 40); // Decrease lightness to 40% for darker colors
}

export const replacePlaceholders = (template, values) => {
  if (!template || isEmpty(values)) {
    return template;
  }

  return template.replace(/{(\w+)}/g, (match, placeholder) => {
    // Use the placeholder (like THERAPIST_NAME) to get the value from the `values` object
    return values.hasOwnProperty(placeholder) ? values[placeholder] : match;
  });
};

export function stringToDate(date, inputFormat = "YYYY-MM-DD") {
  return moment(date, inputFormat).toDate();
}

export function getUTCDate(utcDate, format = "YYYY-MM-DD") {
  return moment.utc(utcDate).format(format);
}

export function formatNumber(value, decimalPlaces) {
  if (value === undefined || value === null || isNaN(value)) {
    return 0;
  }
  return parseFloat(value.toFixed(decimalPlaces));
}

export function convertToMomentDate(date, inputFormat = "YYYY-MM-DD") {
  return date ? moment(date, inputFormat).format("DD/MM/YYYY") : "--";
}

export function convertToMomentTime(time, inputFormat = "HH:mm:ss") {
  return time ? moment(time, inputFormat).format("hh:mm A") : "--";
}

export const getRemainingWords = (text, limit) => {
  const wordsCount = text.trim() ? text.trim().split(/\s+/).length : 0;
  const remainingWords = Math.max(limit - wordsCount, 0);
  return remainingWords;
}

export const getPdfBlob = async (doc, returnBlob = false, fileName = "intake_report.pdf") => {
  const asPdf = pdf([]);
  asPdf.updateContainer(doc);
  const blob = await asPdf.toBlob();

  if (returnBlob) {
    return blob;
  }

  return new File([blob], fileName, { type: blob.type });
}

export const createSlug = (input) => {
  return input
    .toString()                      // Ensure the input is a string
    .trim()                          // Remove leading/trailing spaces
    .toLowerCase()                   // Convert to lowercase
    .replace(/[^a-z0-9\s-]/g, "")    // Remove non-alphanumeric characters
    .replace(/\s+/g, "-")            // Replace spaces with hyphens
    .replace(/-+/g, "-");            // Remove multiple consecutive hyphens
}

export const convert12HourTime = (time, format = "HH:mm") => {

  return time ? moment(time, format).format("hh:mm A") : "--"
}

export const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

export const generateCustomPath = (path, params) => {
  return path.replace(/:([a-zA-Z0-9_]+)/g, (_, key) => params[key] || "");
};


//Few css are not supported in pdf library, so custom js to break line over 30 char 
export const wrapTextCustom = (text) => {
  if (!text) {
    return "";
  }
  const maxLineLength = 30;
  const words = text?.split(' ');
  let lines = [];
  let currentLine = '';
  words?.forEach(word => {
    if ((currentLine + word).length > maxLineLength) {
      lines.push(currentLine.trim());
      currentLine = word + ' ';
    } else {
      currentLine += word + ' ';
    }
  });
  if (currentLine) {
    lines.push(currentLine.trim());
  }
  return lines.join('\n');
};


export const isValidValue = (val) => !!val && val !== "null";

export const getQuestionById = (questionId, questions) => {
  if (!questions?.length) return null;

  return questions.find(q => q.id === questionId);
}

export const isHTMLContentEmpty = (html) => {
  if (!html) return true;

  // Remove all tags and whitespace
  const stripped = html.replace(/<[^>]*>/g, '').trim();

  return stripped.length === 0;
};

export const ReportsNoRecordMessage = ({ msg = 'No Record Found', className = "", ...props }) => {
  return <div {...props} className={`py-2 mt-5 d-flex align-items-center justify-content-center w-100 ${"guardian-not-assigned-wrapper"} ${className}`}>
    {msg}
  </div>
}

export function normalizeHtmlSpaces(html) {
  if (!html) {
    return "";
  }
  // Ensure space before opening inline tags
  html = html.replace(/([a-zA-Z0-9.,!?])<(strong|em|b|i)>/g, '$1 <$2>');

  // Ensure space after closing inline tags
  html = html.replace(/<\/(strong|em|b|i)>([a-zA-Z0-9.,!?])/g, '</$1> $2');

  // Collapse multiple spaces to a single space
  html = html.replace(/\s{2,}/g, ' ');

  return html;
}

export const normalizeNewlines = (str) => {
  if (!str) return str;
  // If the content has no HTML tags, it's plain text — convert \n to <br/>
  const hasHtmlTags = /<[a-z][\s\S]*>/i.test(str);
  if (!hasHtmlTags) {
    return str.replace(/\n/g, "<br/>");
  }
  return str;
};

export const truncateUrl = (name, maxLength = 20) => {
  if (!name) return "";
  const decodedName = decodeURIComponent(name);
  return decodedName.length > maxLength
    ? decodedName.substring(0, maxLength) + "..."
    : decodedName;
};

export const deepDiff = (obj1, obj2, path = "") => {
  let changes = {};

  // guard against null or undefined
  if (obj1 == null && obj2 == null) return changes;

  for (const key in obj1) {
    const val1 = obj1[key];
    const val2 = obj2 ? obj2[key] : undefined;
    const currentPath = path ? `${path}.${key}` : key;

    // both are objects or arrays → recursettps://nausheen.blob.core.windows.net/nausheen-container/dummyImage_1774264576595.jpg?sv=2025-07-05&st=2026-03-23T11%3A16%3
    if (
      val1 &&
      val2 &&
      typeof val1 === "object" &&
      typeof val2 === "object" &&
      !Array.isArray(val1) &&
      !Array.isArray(val2)
    ) {
      Object.assign(changes, deepDiff(val1, val2, currentPath));
    } else if (!isEqual(val1, val2)) {
      changes[currentPath] = { old: val2, new: val1 };
    }
  }

  return changes;
};

export const truncateString = (text, limit = 30) => {
  if (!text) return "";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};

export const getClientDetailPathByType = (clientType) => {
  switch (clientType) {
    case "school":
      return SCHOOL_CLIENT_DETAIL;
    case "home_education":
      return HOME_EDUCATION_CLIENT_DETAIL;
    case "private":
      return PRIVATE_CLIENT_DETAIL;
    case "chatter":
      return CHATTER_CLIENT_DETAIL
  }
}

export const getClientListPathByType = (clientType) => {
  switch (clientType) {
    case "school":
      return SCHOOL_CLIENT_LIST;
    case "home_education":
      return HOME_EDUCATION_CLIENT_LIST;
    case "private":
      return PRIVATE_CLIENT_LIST;
    case "chatter":
      return CHATTER_CLIENT_LIST;
  }
}

export const getClientBreadCrumbs = (clientId, clientType, clientDetails, currentPage) => {
  return [
    { label: `${formatString(clientType)} Client`, path: getClientListPathByType(clientType) },
    { label: userFullName(clientDetails) || "Client Details", path: generatePath(getClientDetailPathByType(clientType), { id: clientId }) },
    { label: currentPage },
  ];
}

export const NoRecordMessage = ({ msg = 'No Record Found', className = "", ...props }) => {
  return <div {...props} className={`py-2 d-flex align-items-center justify-content-center w-100 ${"guardian-not-assigned-wrapper"} ${className}`}>
    {msg}
  </div>
}

export const parseHtmlHelper = (html) => {
  return parse(html || "")
}

export const ConvertToRoman = (num) => {
  const romanMap = [
    { value: 1000, symbol: "M" },
    { value: 900, symbol: "CM" },
    { value: 500, symbol: "D" },
    { value: 400, symbol: "CD" },
    { value: 100, symbol: "C" },
    { value: 90, symbol: "XC" },
    { value: 50, symbol: "L" },
    { value: 40, symbol: "XL" },
    { value: 10, symbol: "X" },
    { value: 9, symbol: "IX" },
    { value: 5, symbol: "V" },
    { value: 4, symbol: "IV" },
    { value: 1, symbol: "I" },
  ];

  let result = "";
  for (let i = 0; i < romanMap.length; i++) {
    while (num >= romanMap[i].value) {
      result += romanMap[i].symbol;
      num -= romanMap[i].value;
    }
  }
  return result;
};


export const getMoodValue = (sectionKey, optionKey) => {
  const moodMappings = {
    ENGAGEMENT: {
      DIFFICULT_TO_ENGAGE: 1,
      ENGAGED_WITH_PROMPTING: 2,
      EASILY_ENGAGED: 3,
    },
    ATTENTION: {
      NEEDED_FREQ_REDIRECTION: 1,
      MILDLY_DISTRACTED: 2,
      SUSTAINED: 3,
    },
  };

  return moodMappings[sectionKey]?.[optionKey] || null;
};

export const getFileNameFromUrl = (url) => {
  if (!url) return "";

  return url.split('/').pop().split('?')[0];
};

export const normalizeUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `http://${url}`;
};